export default __webpack_public_path__ + "static/imgAboutUs-2e1b23888c12bb56d7cd9d35ce55ef6a.webp";